import { Droplets } from "lucide-react";

const WORDS = [
  "Intelligente Schwimmbadtechnik",
  "Kristallklares Wasser",
  "Exklusives Design",
  "Maßgeschneiderte Poolsteuerung",
  "Qualität made in Germany",
];

export default function EditorialMarquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="editorial-brand-marquee"
      className="relative overflow-hidden border-y border-white/8 border-white/10 bg-[#07101D] py-5 select-none"
    >
      <div className="animate-marquee flex w-max items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-display font-bold text-lg sm:text-xl tracking-wide text-slate-500/80 uppercase whitespace-nowrap">
                  {w}
                </span>
                <Droplets className="w-4 h-4 text-cyan-500/50 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
